export default __webpack_public_path__ + "9f06ff097dd3ba0c4766a41904848dfd.png";